import ResetForm from "../components/reset-form";

export function ResetPasswordPage() {
  return <ResetForm />
}
